import React, { Component } from 'react';
import Form from '../Form/Form';
import { sanitizeHtml } from '../sanitize';

export class Contact5050 extends Component {
    static displayName = Contact5050.name;

    constructor(props) {
        super(props);
        this.state = {
            componentId: props.componentId,
            contact5050: null
        };
    }

    componentDidMount() {
        this.getComponentData();
    }

    render() {
        let title;
        let description;
        let formId;
        let imageLink;
        let form;
        let content;
        let format;
        if (this.state.contact5050 != null) {
            title = this.state.contact5050.title;
            description = this.state.contact5050.description;
            formId = this.state.contact5050.formId;
            imageLink = this.state.contact5050.imageLink;
            content = this.state.contact5050.content;
            format = this.state.contact5050.format;

            form = <Form formId={formId} />;
        }

        let sideContainer;
        let formContainerClasses = "contact-input-wrapper";
        if (format != "imageLeft" && format != "contentLeft") {
            formContainerClasses += " dual-grid__1-2";
        }
        else {
            if (format == "imageLeft") {
                sideContainer = <div className="image-full-bg">
                    <img alt="form image" src={imageLink} />
                </div>;
            }
            else if (format == "contentLeft") {
                sideContainer = <div className="content-left">
                    <div className='html-editor-wrap general-html-editor-wrapper' dangerouslySetInnerHTML={{ __html: sanitizeHtml(content) }}></div>
                </div>;
            }
        }

        return (
            <div className="grid-half getstarted2 contact5050">
                {sideContainer}

                <div className={formContainerClasses}>
                    <h2 className="lightweight text-right tsdark">{title}<hr /></h2>
                    <p className="smallfont text-center">{description}</p>

                    {form}
                </div>
            </div>
        );
    }

    async getComponentData() {
        const response = await fetch('Components/GetContact5050?componentId=' + this.state.componentId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();

        if (data != null) {
            this.setState({
                contact5050: data
            });
        }
    }
}